import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import Button from '@atlaskit/button/default/button';
import DropdownMenu, {
	CustomTriggerProps,
	DropdownItem,
	DropdownItemGroup,
} from '@atlaskit/dropdown-menu';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ShieldIcon from '@atlaskit/icon/core/shield';
import WrenchIcon from '@atlaskit/icon-lab/core/wrench';

import { useRoutes } from '@/common/hooks';

import { messages } from './messages';

const FastshiftToolsMenuTrigger = ({
	triggerRef,
	...triggerProps
}: CustomTriggerProps<HTMLButtonElement>) => {
	const { formatMessage } = useIntl();

	return (
		<Button
			ref={triggerRef}
			{...triggerProps}
			appearance="subtle"
			iconBefore={WrenchIcon}
			iconAfter={ChevronDownIcon}
			testId="fastshift-tools-menu-trigger"
		>
			{formatMessage(messages.toolsButtonLabel)}
		</Button>
	);
};

export const FastshiftToolsMenu = () => {
	const navigate = useNavigate();
	const { paths } = useRoutes();
	const { formatMessage } = useIntl();

	return (
		<DropdownMenu<HTMLButtonElement>
			shouldRenderToParent
			spacing="compact"
			trigger={FastshiftToolsMenuTrigger}
			testId="fastshift-tools-menu"
		>
			<DropdownItemGroup>
				<DropdownItem
					elemBefore={<ShieldIcon label="" color="currentColor" />}
					onClick={() => navigate(paths.csProfiler)}
					testId="fastshift-tools-menu-cs-profiler-item"
				>
					{formatMessage(messages.csProfilerToolLabel)}
				</DropdownItem>
			</DropdownItemGroup>
		</DropdownMenu>
	);
};
